import IAuthUserRepository from 'domain/interfaces/repositories/IAuthUserRepository'
import { ResetPasswordAuthUserCommandRequest } from 'domain/entities/authUser'

export const resetPasswordAuthUserCommand = (
  repository: IAuthUserRepository,
  data: ResetPasswordAuthUserCommandRequest,
) => {
  return repository.resetPassword(data)
}
